import type { CalendarFilterState } from '@/App/Calendar/components/Filters'

type DateRange = {
  start: string
  end: string
}

export const buildCalendarParams = (filters: CalendarFilterState, dateRange: DateRange) => ({
  start: filters.dateStart ?? dateRange.start,
  end: filters.dateEnd ?? dateRange.end,
  ...(filters.agendaId && { agendaId: filters.agendaId }),
  ...(filters.status && { status: filters.status }),
  ...(filters.search && { search: filters.search }),
})
